/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

export const clearProductSelectionFeedback = createAction('products/clearProductSelectionFeedback');

export const reducer = (builder) => {
  builder.addCase(clearProductSelectionFeedback, (state) => {
    state.ui.selectionFeedback = null;
  });
};
